module.exports = __webpack_public_path__ + "img/shape_hearth.46bc37a.webp";